<template>
	<v-dialog
			content-class="addPotentialClientsWrapper"
			:value="true"
			persistent
			width="960"
			transition="dialog-bottom-transition"
	>
		<div class="addPotentialClients">
			<div class="addPotentialClients_header">
				<span>{{ currentId ? 'Edit' : 'Create' }} potential client</span>
				<button type="button" @click="closeDialog">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="addPotentialClients_body">
				<div class="fieldBlock groupField">
					<div class="groupField_wrap">
						<field
								margin="0 0 10px 0"
								width="300px"
								label="MC#"
								placeholder="Enter mc"
								:set-input-value="mc"
								@updateInput="onInput($event, 'mc')"
						></field>
						<field
								margin="0 0 10px 10px"
								width="300px"
								label="Trucks quantity"
								placeholder="Enter trucks quantity"
								type="number"
								:setInputValue="truck_quantity"
								@updateInput="onInput($event, 'truck_quantity')"
						></field>
						<field
								margin="0 0 10px 10px"
								width="300px"
								label="Сarrier name"
								placeholder="Enter сarrier name"
								:set-input-value="carrier"
								@updateInput="onInput($event, 'carrier')"
						></field>
					</div>
					<div class="groupField_wrap">
						<field
								margin="0 0 10px 0"
								width="300px"
								label="Contact name"
								placeholder="Enter contact name"
								:set-input-value="contact"
								@updateInput="onInput($event, 'contact')"
						></field>
						<field
								margin="0 0 10px 10px"
								width="300px"
								label="Phone"
								placeholder="Enter phone"
								:setInputValue="phone"
								@updateInput="onInput($event, 'phone')"
						></field>
						<field
								:class-error="$v.email && $v.email.$error"
								margin="0 0 10px 10px"
								width="300px"
								label="Email"
								placeholder="Enter email"
								:setInputValue="email"
								@updateInput="onInput($event, 'email')"
						></field>
					</div>
					<div class="groupField_wrap">
						<v-radio-group
								v-model="type"
								row
						>
							<v-radio
									v-for="({ text, value, isDisabled }) in radioList"
									:disabled="isDisabled"
									:key="value"
									:label="text"
									:value="value"
							></v-radio>
						</v-radio-group>
					</div>
					<div>
						<comments-table
								:comments="comment"
								:created_by="created_by"
								:name="created_name"
						></comments-table>
					</div>
				</div>
			</div>
			<button-groups
					:preloader="potentialClientsPreloader"
					:is-btn-safe="getPermissionAction"
					apply-text="submit"
					:created_by="created_by"
					@updateBtnClose="closeDialog"
					@updateSave="onSave"
			></button-groups>
		</div>
		<preload v-if="potentialClientsPreloader"></preload>
	</v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// validate
import { validationMixin } from "vuelidate";
// shared
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import Preload from "@/shared/Preload/Preload";
import { email, required } from "vuelidate/lib/validators";
import CommentsTable from "@/components/Maintenance/PotentialClient/CommentsTable/CommentsTable";

export default {
	name: "AddPotentialClients",
	mixins: [ validationMixin ],
	components: {
		CommentsTable,
		ButtonGroups,
		Preload
	},
	props: {
		currentId: Number,
		typeDefault: Number,
		getPermissionAction: Boolean,
		permissions: Object
	},
	computed: mapGetters([ 'potentialClientsPreloader', 'potentialClients' ]),
	data: () => ({
		type: 1,
		radioList: [
			{ text: 'All', value: 1, isDisabled: false },
			{ text: 'Not interested', value: 2, isDisabled: false },
			{ text: 'Interested', value: 5, isDisabled: false },
			{ text: 'Other', value: 3, isDisabled: false },
			{ text: 'On-boarded', value: 4, isDisabled: false }
		],
		mc: '',
		carrier: '',
		contact: '',
		truck_quantity: '',
		phone: '',
		email: '',
		comment: [],
		created_by: null,
		created_name: ''
	}),
	validations() {
		return {
			email: { required, email },
		};
	},
	methods: {
		...mapActions([
			'onPotentialClientsCreate',
			'onPotentialClientsSave',
			'setAlert',
			'onPotentialClientsEdit',
			'onPotentialClientsDelete',
			'onInvoiceDelete',
			'getPotentialClientsDelete',
			'getInvoiceDelete',
			'onPotentialClientsPreloader',
		]),
		onCommentList(item) {
			this.comment.push(item);
		},
		onCommentDeleteItem(idx) {
			this.comment.splice(idx, 1);
		},
		onCommentEditItem() {
		
		},
		closeDialog() {
			this.$emit('updateClose');
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					type,
					mc,
					carrier,
					contact,
					truck_quantity,
					phone,
					email,
					comment,
				} = this.$data;
				const values = {
					type,
					mc,
					carrier,
					contact,
					truck_quantity,
					phone,
					email,
					comment,
				};

				await this.onPotentialClientsPreloader(true);
				const { status } = await this.onPotentialClientsSave({
					values,
					id: this.currentId,
					typeDefault: this.typeDefault
				});

				if (status) {
					this.closeDialog();
					this.$emit('updateFilterList');
					this.setAlert({ type: "success", message: "Saving Successfully" });
					await this.onPotentialClientsPreloader(false);
				} else {
					await this.setAlert({ type: "error", message: "Saving error" });
					await this.onPotentialClientsPreloader(false);
				}

			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}
		}
	},
	async mounted() {
		if (this.currentId) {
			await this.onPotentialClientsEdit(this.currentId);
		} else {
			await this.onPotentialClientsCreate(null);
		}

		const { row, comment, created_by, created_name } = this.potentialClients;
		this.created_by = created_by;
		this.created_name = created_name;
		if (row) {
			for (const rowKey in row) {
				if (rowKey !== 'comment') this[rowKey] = row[rowKey];
			}
			
			this.comment = comment;

			this.$set(this.radioList[0], 'isDisabled', this.type !== 1);
		}
	}
};
</script>

<style scoped lang="scss">
@import "addPotentialClient";
</style>

<style lang="scss">
@import "../../global";
</style>
